import React, { useState, useEffect }from 'react';
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux"; 
import { Link } from 'react-router-dom';
import { ToastContainer } from 'react-toastify'; 
import ArticleIcon from '@mui/icons-material/Article';
import DashboardIcon from '@mui/icons-material/Dashboard'; 
import FeedIcon from '@mui/icons-material/Feed';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { TodayIs } from 'components/utils/TodayIs';   
import { resetFormatDIAction } from "actions/FormatDIActions";
import { resetLoginAction } from "actions/LoginActions.jsx";  
import ImportScript from 'components/utils/ImportScript';
import Footer from './Footer';
import Person from 'pages/main/Person';
import Login from "pages/login/LoginForm";
import GeneralSettings from 'pages/settings/GeneralSettings';
import ColorSettings from "pages/settings/ColorSettings"; 
import CodeLerSettings from "pages/settings/CodeLerSettings";
import OptTypeSettings from "pages/settings/OptTypeSettings.jsx";
import RoadSettings from "pages/settings/RoadSettings";
import PaymentTypeSettings from "pages/settings/PaymentTypeSettings"; 
import DocumentTypeSettings from "pages/settings/DocumentTypeSettings";
import LanguageSettings from "pages/settings/LanguageSettings";
import CountrySettings from "pages/settings/CountrySettings";
import UserSettings from "pages/users/UserSettings";
import RolesUserSettings from "pages/roles/RolesUserSettings";
import VehiclesSettings from "pages/vehicles/VehiclesSettings";
import VehiclesTrailersSettings from "pages/vehiclesTrailers/VehiclesTrailersSettings";

import PrincipalMenuSettings from "pages/settings/InitPrincipalMenus";
import "css/homeResponsive.css";
import DescriptionSettings from "pages/settings/DescriptionSettings";
import TreatmentTypeSettings from "pages/settings/TreatmentTypeSettings";
import ProcessTypeSettings from "pages/settings/ProcessTypeSettings";
import DangerousnessSettings from "pages/settings/DangerousnessSettings";
import CommunitySettings from "pages/settings/CommunitySettings";   
import ReasonTypeSettings from "pages/settings/ReasonTypeSettings";
import StatusTypeSettings from "pages/settings/StatusTypeSettings"; 
import EndpointSettings from "pages/endpoints/EndpointSettings";
import CompanyTypeSettings from "pages/settings/CompanyTypesSettings";
import MunicipalitySettings from "pages/settings/MunicipalitySettings";
import IncidentTypeSettings from "pages/settings/IncidentTypeSettings";
import SlaTypeSettings from "pages/settings/SlaTypeSettings";
import ResolutionTypeSettings from "pages/settings/ResolutionTypeSettings";
import TypesOfTaxes from "pages/settings/TypesOfTaxesSettings";
import TypesOfPrices from "pages/settings/TypesOfPricesSettings";
import TypesOfUnits from "pages/settings/TypesOfUnitsSettings";
import DepartmentSettings from "pages/commonsarticle/departmentSettings/DepartmentSettings";
import ArticlesButtonSettings from "pages/settings/articlesButtonSettings/ArticlesButtonsSettings"; 
import ProductSettings from "pages/settings/ProductSettings";
import ProductLiquidSettings from "pages/settings/ProductLiquidSettings";
import SheetStatusSettings from "pages/settings/SheetStatusSettings";
import TypesOfSizes from "pages/settings/TypesOfSizesSettings";
import TypesOfVehicles from "pages/settings/TypesOfVehiclesSettings";
import SemiTrailerTypeSettings from "pages/settings/SemiTrailerTypeSettings";
import CraneModelSettings from "pages/settings/CraneModelSettings";

const Home = () => {
 
    const {t,i18n} = useTranslation(['sidebar']); 
    const dispatch = useDispatch(); 
    const username = useSelector((state) => state.loginUser.username);
    const firstName = useSelector((state) => state.loginUser.firstName);  
    const lastName1 = useSelector((state) => state.loginUser.lastName1);  
    const lastName2 = useSelector((state) => state.loginUser.lastName2);  
    const email = useSelector((state) => state.loginUser.email);  
    const enabled = useSelector((state) => state.loginUser.enabled);  
    const aliasuser = useSelector((state) => state.loginUser.aliasuser);  
    const roles = useSelector((state) => state.loginUser.roles);  
    const language = useSelector((state) => state.loginUser.language);
    const defaultStore = useSelector((state) => state.loginUser.defaultStore);  
    const [showModalGeneralSettings, setShowModalGeneralSettings] = useState(false);
    const [indexShowSettings,setIndexShowSettings]=useState(0);
    const [showModalColorSettings, setShowModalColorSettings] = useState(false);
    const [showRoadSettings, setShowModalRoadSettings] = useState(false); 
    const [showCountrySettings, setShowModalCountrySettings] = useState(false);
    const [showDocumentTypeSettings, setShowModalDocumentTypeSettings] = useState(false);
    const [showCommunitySettings, setShowCommunitySettings] = useState(false);
    const [showLanguageSettings, setShowModalLanguageSettings] = useState(false);
    const [showUserSettings,setShowModalUserSettings] = useState(false);
    const [showRolesUserSettings,setShowModalRolesUserSettings] = useState(false);
    const [showVehiclesSettings,setShowVehiclesSettings] = useState(false);
    const [showVehiclesTrailersSettings,setShowVehiclesTrailersSettings] = useState(false);
    
    const [showModalEmployeeSettings, setShowModalEmployeeSettings] = useState(false);
    const [showModalDriverSettings, setShowModalDriverSettings] = useState(true);
    const [showModalFormSettings, setShowModalFormSettings] = useState(false); 
    const [showModalContractSettings, setShowModalContractSettings] = useState(false);
    const [showModalNTSettings, setShowModalNTSettings] = useState(false);   
    const [showModalStoreSettings, setShowModalStoreSettings] = useState(false);
    const [showEndpointSettings, setShowModalEndpointSettings] = useState(false); 
    const [showModalCodeLerSettings, setShowModalCodeLerSettings] = useState(false);
    const [showModalOptTypeSettings, setShowModalOptTypeSettings] = useState(false);
    const [showModalDescriptionSettings, setShowModalDescriptionSettings] = useState(false);
    const [showModalDangerousnessSettings, setShowModalDangerousnessSettings] = useState(false);
    const [showModalProcessTypeSettings, setShowModalProcessTypeSettings] = useState(false);
    const [showModalTreatmentTypeSettings, setShowModalTreatmentTypeSettings] = useState(false); 
    const [showModalShippingsSettings, setShowModalShippingsSettings] = useState(false); 
    const [showModalRegisterBookSettings, setShowModalRegisterBookSettings] = useState(false); 
    const [showModalStatusTypeSettings, setShowModalStatusTypeSettings] = useState(false);
    const [showModalReasonTypeSettings, setShowModalReasonTypeSettings] = useState(false); 
    const [showCompanyTypeSettings, setShowModalCompanyTypeSettings] = useState(false); 
    const [showMunicipalitySettings, setShowMunicipalitySettings] = useState(false); 
    const [showModalIncidentTypeSettings, setShowModalIncidentTypeSettings] = useState(false);  
    const [showModalSlaTypeSettings, setShowModalSlaTypeSettings] = useState(false);  
    const [showModalResolutionTypeSettings, setShowModalResolutionTypeSettings] = useState(false);  
    const [showModalPaymentTypeSettings, setShowModalPaymentTypeSettings] = useState(false); 
    const [showModalArticlesSettings, setShowModalArticlesSettings] = useState(false); 
    const [showModalPurchasesDeliverySettings, setShowModalPurchasesDeliverySettings] = useState(false); 
    const [showModalTypesOfTaxes, setShowModalTypesOfTaxes] = useState(false);
    const [showModalTypesOfPrices, setShowModalTypesOfPrices] = useState(false);
    const [showModalTypesOfUnit, setShowModalTypesOfUnit] = useState(false);
    const [showDepartmentSettings, setShowModalDepartmentSettings] = useState(false);
    const [showArticlesButtonSettings, setShowArticlesButtonSettings] = useState(false); 
    const [showModalProductSettings, setShowModalProductSettings] = useState(false);
    const [showModalProductLiquidSettings, setShowModalProductLiquidSettings] = useState(false);
    const [showModalSheetStatusSettings, setShowModalSheetStatusSettings] = useState(false);
    const [showModalTypesOfSizes, setShowModalTypesOfSizes] = useState(false);
    const [showModalTypesOfVehicles, setShowModalTypesOfVehicles] = useState(false);
    const [showModalSemiTrailerTypeSettings, setShowModalSemiTrailerTypeSettings] = useState(false);
    const [showModalCraneModelSettings, setShowModalCraneModelSettings] = useState(false);
    
    const [showPrincipalMenu, setShowPrincipalMenu] = useState(true);
    const [homeMenuOpen, setHomeMenuOpen] = useState(false);
    const scriptUrl = '/js/sb-admin-2.min.js';
    function changeSelectedLanguage(){
        i18n.language==="es"?i18n.changeLanguage("en"):i18n.changeLanguage("es");
    };
  
    function logOut(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);

        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(showModalEmployeeSettings);
        setShowModalDriverSettings(showModalDriverSettings);
        setShowModalFormSettings(showModalFormSettings);
        setShowModalContractSettings(showModalContractSettings);
        setShowModalNTSettings(showModalNTSettings); 
        setShowModalStoreSettings(showModalStoreSettings);
        setShowModalEndpointSettings(showEndpointSettings);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(showModalShippingsSettings);
        setShowModalRegisterBookSettings(showModalRegisterBookSettings); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(showModalArticlesSettings);
        setShowModalPurchasesDeliverySettings(showModalPurchasesDeliverySettings);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false); 
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
        dispatch(resetLoginAction()); 
        dispatch(resetFormatDIAction());
    };
     
    function openModalUsername(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);

        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(!showUserSettings);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
        setShowModalTypesOfVehicles(false);  
    }

    function openModalEndpoints(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(true);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false);   
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    }

    function openModalRoleUser(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false); 
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(true);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false);    
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    }

    function openModalVehicles(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false); 
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(true);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false); 
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    } 

    function openModalVehiclesTrailers(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false); 
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(true);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false); 
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    }

    function openModalDepartment(){
        setShowModalGeneralSettings(false);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false);
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(true);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false); 
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    }

    function openModalGeneralSettings(){
        setShowModalGeneralSettings(!showModalGeneralSettings);
        setIndexShowSettings(0);
        setShowPrincipalMenu(false); 
        setShowModalColorSettings(false);
        setShowModalRoadSettings(false);
        setShowModalCountrySettings(false);
        setShowModalDocumentTypeSettings(false);
        setShowCommunitySettings(false);
        setShowModalLanguageSettings(false);
        setShowModalUserSettings(false);
        setShowModalRolesUserSettings(false);
        setShowVehiclesSettings(false);
        setShowVehiclesTrailersSettings(false);
        setShowModalEmployeeSettings(false);
        setShowModalDriverSettings(false);
        setShowModalFormSettings(false);
        setShowModalContractSettings(false);
        setShowModalNTSettings(false); 
        setShowModalStoreSettings(false);
        setShowModalEndpointSettings(false);
        setShowModalCodeLerSettings(false);
        setShowModalOptTypeSettings(false);
        setShowModalDescriptionSettings(false);
        setShowModalDangerousnessSettings(false);
        setShowModalProcessTypeSettings(false);
        setShowModalTreatmentTypeSettings(false); 
        setShowModalShippingsSettings(false);
        setShowModalRegisterBookSettings(false); 
        setShowModalStatusTypeSettings(false);
        setShowModalReasonTypeSettings(false); 
        setShowModalCompanyTypeSettings(false);
        setShowMunicipalitySettings(false);
        setShowModalIncidentTypeSettings(false);
        setShowModalSlaTypeSettings(false);
        setShowModalResolutionTypeSettings(false);
        setShowModalPaymentTypeSettings(false);
        setShowModalArticlesSettings(false);
        setShowModalPurchasesDeliverySettings(false);
        setShowModalTypesOfTaxes(false);
        setShowModalTypesOfPrices(false);
        setShowModalTypesOfUnit(false);
        setShowModalDepartmentSettings(false);
        setShowArticlesButtonSettings(false);   
        setShowModalProductSettings(false);
        setShowModalProductLiquidSettings(false);
        setShowModalSheetStatusSettings(false);        
        setShowModalTypesOfSizes(false);
        setShowModalTypesOfVehicles(false);
        setShowModalSemiTrailerTypeSettings(false);
        setShowModalCraneModelSettings(false);
    }
    
    useEffect(
        () => {
            let isMounted = true;
                if (isMounted) {
                    switch (indexShowSettings) {
                        case 1:    
                            return setShowModalLanguageSettings(true); 
                        case 2:    
                            return setShowModalColorSettings(true);
                        case 3:    
                            return setShowModalRoadSettings(true);   
                        case 4:    
                            return setShowCommunitySettings(true);
                        case 5:
                            return setShowModalCountrySettings(true);
                        case 6:  
                            return setShowMunicipalitySettings(true);
                        case 7:    
                            return setShowModalDocumentTypeSettings(true);
                        case 8:  
                            return setShowModalCompanyTypeSettings(true);
                        case 9:  
                            return setShowModalIncidentTypeSettings(true);
                         case 10:  
                            return setShowModalStatusTypeSettings(true);
                        case 11:  
                            return setShowModalReasonTypeSettings(true);
                        case 12:  
                            return setShowModalResolutionTypeSettings(true);
                        case 13:  
                            return setShowModalSlaTypeSettings(true);
                        case 14:    
                            return setShowModalCodeLerSettings(true);
                        case 15:    
                            return setShowModalDescriptionSettings(true);
                        case 16:    
                            return setShowModalTreatmentTypeSettings(true);
                        case 17:    
                            return setShowModalProcessTypeSettings(true);
                        case 18:    
                            return setShowModalDangerousnessSettings(true);
                        case 19:  
                            return setShowModalOptTypeSettings(true);
                        case 20:  
                            return setShowModalProductSettings(true);
                        case 21:  
                            return setShowModalProductLiquidSettings(true);
                        case 22:  
                            return setShowModalSheetStatusSettings(true);
                        case 23:  
                            return setShowModalTypesOfVehicles(true);
                        case 24:  
                            return setShowModalTypesOfTaxes(true);
                        case 25:  
                            return setShowModalTypesOfUnit(true);
                        case 26:  
                            return setShowModalTypesOfPrices(true);
                        case 27:  
                            return setShowModalTypesOfSizes(true);
                        case 28:  
                            return setShowModalPaymentTypeSettings(true);
                        case 29:  
                            return setShowArticlesButtonSettings(true);
                        case 30:  
                            return setShowModalSemiTrailerTypeSettings(true);
                        case 31:  
                            return setShowModalCraneModelSettings(true);
                        default:
                            return null;
                }
            }
            return()=>{ isMounted=false;}    
        },
        [indexShowSettings]
      );
   
    return (
    <>
        <ImportScript resourceUrl={scriptUrl} />
        <ToastContainer></ToastContainer>
        {(enabled===false || roles===undefined || roles[0]===undefined || roles[0].listmenus===undefined) ? <Login/>:
        <div id="page-top">

            {/* Page Wrapper */}
            <div id="wrapper" className={showPrincipalMenu ? `home-dashboard-page ${homeMenuOpen ? "home-menu-open" : ""}` : undefined}>
                {showPrincipalMenu && homeMenuOpen && <button type="button" className="home-menu-backdrop" aria-label="Cerrar menú" onClick={() => setHomeMenuOpen(false)} />}

                {/* Sidebar */}
                <ul className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion" id="accordionSidebar">

                    {showPrincipalMenu && <li className="home-menu-close"><button type="button" onClick={() => setHomeMenuOpen(false)} aria-label="Cerrar menú">Cerrar ×</button></li>}
                    {/* Sidebar - Brand */}
                    <Link className="sidebar-brand d-flex align-items-center justify-content-center" to="/home">
                        <div className="sidebar-brand-icon rotate-n-15">
                            <DashboardIcon/>
                        </div>
                        <div className="sidebar-brand-text mx-3">{t('Text_Title')}</div>
                    </Link>

                    {/* Divider */}
                    <hr className="sidebar-divider my-0"/>

                    {/* Nav Item - Dashboard */}
                    <li className="nav-item active">
                        <div className="nav-link">
                            <i className="fas fa-fw fa-tachometer-alt"></i>
                            <span>{t('Menu_Main')}</span></div>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    <div className="sidebar-heading">
                        {t('Text_Interface')}
                    </div>

                    {/* Nav Item - Stores Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Stores")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseStores"
                            aria-expanded="true" aria-controls="collapseStores">
                                <SettingsIcon/>
                                <span> {t('Menu_Stores')}</span>
                            </Link>
                            <div id="collapseStores" className="collapse" aria-labelledby="headingStores" data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Stores')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Stores_Stores")) &&
                                        <Link className="collapse-item"  to="/store">{t('SubMenu_Stores_Stores')} </Link>
                                    }
                                </div>
                            </div>
                        </li>
                    }

                     {/* Nav Item - Employees Collapse Menu */}
                     {roles[0].listmenus.find((key)=>(key.name==="Menu_Employees")) &&
                    
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseEmployees"
                                aria-expanded="true" aria-controls="collapseEmployees">
                                <SettingsIcon/>
                                <span> {t('Menu_Employees')}</span>
                            </Link>
                            <div id="collapseEmployees" className="collapse" aria-labelledby="headingEmployees"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Employees')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Employees")) &&
                                        <Link className="collapse-item"  to="/employee">{t('SubMenu_Employees_Employees')} </Link>
                                    }             
                                </div>
                            </div>
                        </li>
                    } 

                    {/* Nav Item - DRIVERS Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Drivers")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseDrivers"
                                aria-expanded="true" aria-controls="collapseDrivers">
                                <SettingsIcon/>
                                <span> {t('Menu_Drivers')}</span>
                            </Link>
                            <div id="collapseDrivers" className="collapse" aria-labelledby="headingDrivers"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Drivers')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Drivers")) &&
                                        <Link className="collapse-item"  to="/driver">{t('SubMenu_Drivers_Drivers')} </Link>
                                    }             
                                </div>
                            </div>
                        </li>
                    }
                    
                    {/* Nav Item - ARTICLES Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Articles")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseArticles"
                                aria-expanded="true" aria-controls="collapseArticles">
                                <ArticleIcon/>
                                <span> {t('Menu_Articles')}</span>
                            </Link>
                            <div id="collapseArticles" className="collapse" aria-labelledby="headingArticles"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Articles')}:</h6>
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Articles"))?
                                    <Link className="collapse-item"  to="/article">{t('SubMenu_Articles')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/home">{t('SubMenu_Articles')} </Link>}
                                
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Department"))?
                                    <Link className="collapse-item"  to="/home" onClick={openModalDepartment}>{t('SubMenu_Departments')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/home">{t('SubMenu_Departments')} </Link>}
                                    
                                    
                                </div>
                            </div>
                        </li>
                    }
                    
                    {/* Nav Item - IN/OUT Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Purchases")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapsePurchases"
                                aria-expanded="true" aria-controls="collapsePurchases">
                                <ArticleIcon/>
                                <span> {t('Menu_Purchases')}</span>
                            </Link>
                            <div id="collapsePurchases" className="collapse" aria-labelledby="headingPurchases"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Purchases')}:</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Purchases"))?
                                    <Link className="collapse-item"  to="/purchasedeliveryin">{t('SubMenu_Purchases_In')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/home">{t('SubMenu_Purchases_In')} </Link>}
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Purchases"))?
                                    <Link className="collapse-item"  to="/purchasedeliveryout" onClick={openModalDepartment}>{t('SubMenu_Purchases_Out')} </Link>:
                                    <Link className="collapse-item" style={{ textDecorationLine: 'line-through' }} to="/home">{t('SubMenu_Purchases_Out')} </Link>}
                                </div>
                            </div>
                        </li>
                    }
                    {/* Nav Item - VEHICLES Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Handle_Store_View_Vehicle")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapsevehicles"
                                aria-expanded="true" aria-controls="collapsevehicles">
                                <SettingsIcon/>
                                <span> {t('Menu_Vehicles')}</span>
                            </Link>
                            <div id="collapsevehicles" className="collapse" aria-labelledby="headingvehicles"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Vehicles')}</h6>
                                    <Link className="collapse-item"  to="/home" onClick={openModalVehicles}>{t('SubMenu_Vehicles_Filters')} </Link> 
                                    {roles[0].listmenus.find((key)=>(key.name==="Handle_Store_View_Trailers"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalVehiclesTrailers}>{t('SubMenu_VehiclesTrailers_Filters')} </Link> 
                                    }
                                </div>
                            </div>
                        </li> 
                    } 
                     {/* Nav Item - SHIPPING BILL Collapse Menu */}
                     {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Shippings")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseShippings"
                                aria-expanded="true" aria-controls="collapseShippings">
                                <SettingsIcon/>
                                <span> {t('Menu_Shippings')}</span>
                            </Link>
                            <div id="collapseShippings" className="collapse" aria-labelledby="headingShippings"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Shippings')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Shippings")) &&
                                        <Link className="collapse-item"  to="/shipping">{t('SubMenu_Shippings_Contracts')} </Link>
                                    }             
                                </div>
                            </div>
                        </li>
                    }

                    {/* Nav Item - Contracts Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Contacts")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseContracts"
                                aria-expanded="true" aria-controls="collapseContracts">
                                <SettingsIcon/>
                                <span> {t('Menu_Contract')}</span>
                            </Link>
                            <div id="collapseContracts" className="collapse" aria-labelledby="headingContracts"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Contracts')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Contacts")) &&
                                        <Link className="collapse-item"  to="/contract">{t('SubMenu_Contracts_Contracts')} </Link>
                                    }             
                                </div>
                            </div>
                        </li>
                    }

                    {/* Nav Item - NTS Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_NTs")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseNTs"
                                aria-expanded="true" aria-controls="collapseNTs">
                                <SettingsIcon/>
                                <span> {t('Menu_NT')}</span>
                            </Link>
                            <div id="collapseNTs" className="collapse" aria-labelledby="headingNTs"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_NTs')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_NTs")) &&
                                        <Link className="collapse-item"  to="/nt">{t('SubMenu_Nts_Nts')} </Link>
                                    }             
                                </div>
                            </div>
                        </li>
                    }

                    {/* Nav Item - RegisterBook Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Register_Book_Store_Master")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseRegisterBook"
                                aria-expanded="true" aria-controls="collapseRegisterBook">
                                <SettingsIcon/>
                                <span> {t('Menu_RegisterBook')}</span>
                            </Link>
                            <div id="collapseRegisterBook" className="collapse" aria-labelledby="headingContracts"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_RegisterBook')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Register_Book_Store_Master")) &&
                                        <Link className="collapse-item"  to="/registerbook">{t('SubMenu_RegisterBook')} </Link>
                                    }    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Emails"))&&
                                        <Link className="collapse-item"  to="/receivedemails" >{t('SubMenu_Emails_Emails')} </Link>
                                    }   
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Emails"))&&
                                        <Link className="collapse-item"  to="/sentemails" >{t('SubMenu_Emails_Sent_Emails')} </Link>
                                    }   
                                </div>
                            </div>
                        </li>
                    }
                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_INCIDENTSEMAILS")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseIncidentEmail"
                                aria-expanded="true" aria-controls="collapseIncidentEmail">
                                <SettingsIcon/>
                                <span> {t('Menu_IncidentEmails')}</span>
                            </Link>
                            <div id="collapseIncidentEmail" className="collapse" aria-labelledby="headingIncidentEmail"
                            data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_IncidentEmails')}</h6>
                                    <Link className="collapse-item"  to="/incidentemail">{t('SubMenu_IncidentEmails_Emails')} </Link>
                                </div>
                            </div>
                        </li>
                    } 

                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Sidebar - INFORMATION */}
                    <li className="nav-item active">
                        <Link className="nav-link" to="/home">
                            <FeedIcon/>
                            <span> {t('Text_Information')}</span>
                        </Link>
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_User')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { username==='' ? t('Text_UserEmpty'): username}
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_Alias')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { aliasuser==='' ? t('Text_AliasEmpty'): aliasuser}
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_Name')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { firstName==='' ? t('Text_NameEmpty'): firstName+ ' '+ (lastName1===''?'':lastName1+' ')+ (lastName2===''?'':lastName2+' ')}
                    </li>

                    <div className="sidebar-heading">
                        {t('Text_Email')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { email==='' ? t('Text_EmailEmpty'): email}
                    </li>

                    <div className="sidebar-heading">
                        {t('Text_Role')}
                    </div>
                    {roles==null? t('Text_RoleEmpty'):roles.slice(0, 5).map((post) =>
                        <li className="sidebar-heading text-warning" key={post.id}>
                            {post.name}
                        </li>
                    )}
                    <div className="sidebar-heading">
                        {t('Text_Currentlanguage')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { language.code==='es' ? language.namees: language.nameen}
                    </li>
                    <div className="sidebar-heading">
                        {t('Text_StoreSelected')}
                    </div>
                    <li className="sidebar-heading text-warning">
                        { defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                    </li>
                    <br/>
                    {/* Divider */}
                    <hr className="sidebar-divider"/>

                    {/* Heading */}
                    <div className="sidebar-heading">
                        {t('Text_Admin')}
                    </div>

                    {/* Nav Item - Admin Collapse Menu */}
                    {roles[0].listmenus.find((key)=>(key.name==="Menu_Settings")) &&
                        <li className="nav-item">
                            <Link className="nav-link collapsed" to="/home" data-toggle="collapse" data-target="#collapseAdmin"
                                aria-expanded="true" aria-controls="collapseAdmin">
                                <SettingsIcon/>
                                <span> {t('Menu_Settings')}</span>
                            </Link>
                            <div id="collapseAdmin" className="collapse" aria-labelledby="headingAdmin"
                                data-parent="#accordionSidebar">
                                <div className="bg-white py-2 collapse-inner rounded">
                                    <h6 className="collapse-header">{t('Custom_Menu_Settings')}</h6>
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Settings"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalGeneralSettings}>{t('SubMenu_Settings_Settings')} </Link> 
                                    }
                                    
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_TypesDi"))&&
                                        <Link className="collapse-item"  to="/formatdi">{t('SubMenu_Settings_TypesDi')} </Link>
                                    } 
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Users"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalUsername}>{t('SubMenu_Settings_Users')} </Link>
                                    }
                                    {roles[0].listmenus.find((key)=>(key.name==="SubMenu_Settings_Roles"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalRoleUser}>{t('SubMenu_Settings_Roles')} </Link>
                                    } 
                                    {roles[0].listmenus.find((key)=>(key.name==="Handle_Store_View_ENDPOINT"))&&
                                        <Link className="collapse-item"  to="/home" onClick={openModalEndpoints}>{t('SubMenu_Settings_Endpoints')} </Link>
                                    }
                                    <Link className="collapse-item" to="/home" onClick={changeSelectedLanguage}>{i18n.language==="es"?t('SubMenu_Settings_ChangeToEnglish'):t('SubMenu_Settings_ChangeToSpanish')}</Link>
                                    
                                </div>
                            </div>
                        </li> 
                    }
                    {/* Nav Item - Charts */}                  
                    <li className="nav-item">
                        <Link className="nav-link" to="/"  onClick={logOut}>
                            <LogoutIcon/>
                            <span>{t('Menu_LogOut')}</span>
                        </Link>
                    </li>

                    {/* Divider */}
                    <hr className="sidebar-divider d-none d-md-block"/>

                    {/* Sidebar Toggler (Sidebar) */}
                    <div className="text-center d-none d-md-inline">
                        <button className="rounded-circle border-0" id="sidebarToggle"></button>
                    </div>
 
                </ul>
                {/* End of Sidebar */}

                {/* Content Wrapper */}
                <div id="content-wrapper" className="d-flex flex-column">

                {/* Main Content */}
                <div id="content">

                    {/* Topbar  */}
                    <nav className="navbar navbar-expand navbar-light bg-white topbar mb-4 static-top shadow">

                        {/* Sidebar Toggle (Topbar)  */}
                        <button id={showPrincipalMenu ? undefined : "sidebarToggleTop"} type="button" className="btn btn-link d-md-none rounded-circle mr-3 home-menu-toggle" aria-label="Abrir menú" aria-expanded={showPrincipalMenu ? homeMenuOpen : undefined} aria-controls="accordionSidebar" onClick={showPrincipalMenu ? () => setHomeMenuOpen(!homeMenuOpen) : undefined}>
                            <i className="fa fa-bars"></i>
                        </button>
                        
                        {/* Topbar Navbar */}
                        
                        <ul className="navbar-nav ml-auto">
                            <Person/>
                            <div className="topbar-divider d-none d-sm-block"></div>
                                <div className="driver-name-ok home-header-company" title={defaultStore.tradename || t("Text_StoreEmpty")}>
                                    <br/>
                                    {t('Text_StoreSelected')}&nbsp;{ defaultStore.tradename===null ? t('Text_StoreEmpty'):defaultStore.tradename }
                                </div>      
                            <div className="topbar-divider d-none d-sm-block"></div>
                            {/* Nav Item - User Information */}
                            <li className="nav-item dropdown no-arrow mx-1 home-header-date">
                            <br/>
                            <span className="mr-2 d-none d-lg-inline text-gray-600 small">
                                <TodayIs/>  
                            </span>
                            </li>
                        </ul>
                    </nav>
                    {/* End of Topbar */}
                
                
                {/* Show Modals */}
                <PrincipalMenuSettings  
                    showPrincipalMenu={showPrincipalMenu}
                    setIndexShowSettings={setIndexShowSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                    setShowPrincipalMenu={setShowPrincipalMenu}
                />
                <GeneralSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showModalGeneralSettings={showModalGeneralSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    indexShowSettings={indexShowSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                />
                <ColorSettings  
                    showModalColorSettings={showModalColorSettings}
                    setShowModalColorSettings={setShowModalColorSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}  
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <CodeLerSettings  
                    showModalCodeLerSettings={showModalCodeLerSettings}
                    setShowModalCodeLerSettings={setShowModalCodeLerSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false} 
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                 <OptTypeSettings  
                    showModalOptTypeSettings={showModalOptTypeSettings}
                    setShowModalOptTypeSettings={setShowModalOptTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <TreatmentTypeSettings  
                    showModalTreatmentTypeSettings={showModalTreatmentTypeSettings}
                    setShowModalTreatmentTypeSettings={setShowModalTreatmentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false} 
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                /> 
                <IncidentTypeSettings  
                    showModalIncidentTypeSettings={showModalIncidentTypeSettings}
                    setShowModalIncidentTypeSettings={setShowModalIncidentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <ResolutionTypeSettings  
                    showModalResolutionTypeSettings={showModalResolutionTypeSettings}
                    setShowModalResolutionTypeSettings={setShowModalResolutionTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <SlaTypeSettings  
                    showModalSlaTypeSettings={showModalSlaTypeSettings}
                    setShowModalSlaTypeSettings={setShowModalSlaTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <ProcessTypeSettings  
                    showModalProcessTypeSettings={showModalProcessTypeSettings}
                    setShowModalProcessTypeSettings={setShowModalProcessTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <DangerousnessSettings  
                    showModalDangerousnessSettings={showModalDangerousnessSettings}
                    setShowModalDangerousnessSettings={setShowModalDangerousnessSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false} 
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />
                <DescriptionSettings  
                    showModalDescriptionSettings={showModalDescriptionSettings}
                    setShowModalDescriptionSettings={setShowModalDescriptionSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                />  
                <CommunitySettings  
                    showCommunitySettings={showCommunitySettings} 
                    setShowCommunitySettings={setShowCommunitySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <DocumentTypeSettings  
                    showDocumentTypeSettings={showDocumentTypeSettings} 
                    setShowModalDocumentTypeSettings={setShowModalDocumentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <LanguageSettings  
                    showLanguageSettings={showLanguageSettings} 
                    setShowModalLanguageSettings={setShowModalLanguageSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <CompanyTypeSettings  
                    showCompanyTypeSettings={showCompanyTypeSettings} 
                    setShowModalCompanyTypeSettings={setShowModalCompanyTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <MunicipalitySettings  
                    showMunicipalitySettings={showMunicipalitySettings} 
                    setShowMunicipalitySettings={setShowMunicipalitySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                /> 
                <StatusTypeSettings  
                    showModalStatusTypeSettings={showModalStatusTypeSettings} 
                    setShowModalStatusTypeSettings={setShowModalStatusTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}   
                /> 
                <ReasonTypeSettings  
                    showModalReasonTypeSettings={showModalReasonTypeSettings} 
                    setShowModalReasonTypeSettings={setShowModalReasonTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}   
                /> 
                <ProductSettings  
                    showModalProductSettings={showModalProductSettings} 
                    setShowModalProductSettings={setShowModalProductSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}
                /> 
                <ProductLiquidSettings  
                    showModalProductLiquidSettings={showModalProductLiquidSettings} 
                    setShowModalProductLiquidSettings={setShowModalProductLiquidSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}   
                /> 
                <SheetStatusSettings  
                    showModalSheetStatusSettings={showModalSheetStatusSettings} 
                    setShowModalSheetStatusSettings={setShowModalSheetStatusSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}   
                /> 
                <RoadSettings   
                    showRoadSettings={showRoadSettings} 
                    setShowModalRoadSettings={setShowModalRoadSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false} 
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <CountrySettings  
                    showCountrySettings={showCountrySettings} 
                    setShowModalCountrySettings={setShowModalCountrySettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false}
                    setShowModalDriverSettings={setShowModalDriverSettings}
                    isDriver={false}
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false}
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalNTSettings={setShowModalNTSettings}
                    isNT={false}
                    setShowModalShippingsSettings={setShowModalShippingsSettings}
                    isShipping={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <UserSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showUserSettings={showUserSettings} 
                    setShowModalUserSettings={setShowModalUserSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                />
                <RolesUserSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showRolesUserSettings={showRolesUserSettings} 
                    setShowModalRolesUserSettings={setShowModalRolesUserSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                />
                <VehiclesSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showVehiclesSettings={showVehiclesSettings} 
                    setShowVehiclesSettings={setShowVehiclesSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                /> 
                <VehiclesTrailersSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showVehiclesTrailersSettings={showVehiclesTrailersSettings} 
                    setShowVehiclesTrailersSettings={setShowVehiclesTrailersSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                /> 
                 <EndpointSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    showEndpointSettings={showEndpointSettings} 
                    setShowModalEndpointSettings={setShowModalEndpointSettings}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                /> 
                <TypesOfTaxes  
                    showModalTypesOfTaxes={showModalTypesOfTaxes}
                    setShowModalTypesOfTaxes={setShowModalTypesOfTaxes} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}  
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfPrices  
                    showModalTypesOfPrices={showModalTypesOfPrices}
                    setShowModalTypesOfPrices={setShowModalTypesOfPrices} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}  
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                /> 
                <TypesOfSizes  
                    showModalTypesOfSizes={showModalTypesOfSizes}
                    setShowModalTypesOfSizes={setShowModalTypesOfSizes} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}  
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <TypesOfVehicles  
                    showModalTypesOfVehicles={showModalTypesOfVehicles}
                    setShowModalTypesOfVehicles={setShowModalTypesOfVehicles} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}  
                /> 
                <SemiTrailerTypeSettings  
                    showModalSemiTrailerTypeSettings={showModalSemiTrailerTypeSettings}
                    setShowModalSemiTrailerTypeSettings={setShowModalSemiTrailerTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}  
                /> 
                 <CraneModelSettings  
                    showModalCraneModelSettings={showModalCraneModelSettings}
                    setShowModalCraneModelSettings={setShowModalCraneModelSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings}  
                /> 
                <TypesOfUnits  
                    showModalTypesOfUnit={showModalTypesOfUnit}
                    setShowModalTypesOfUnit={setShowModalTypesOfUnit} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}
                    isArticle={false}  
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                 
                 <PaymentTypeSettings  
                    showModalPaymentTypeSettings={showModalPaymentTypeSettings}
                    setShowModalPaymentTypeSettings={setShowModalPaymentTypeSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false}
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                    setShowModalRegisterBookSettings={setShowModalRegisterBookSettings}
                    isRegisterBook={false}
                /> 
                <DepartmentSettings  
                    setShowPrincipalMenu={setShowPrincipalMenu}
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    showDepartmentSettings={showDepartmentSettings}
                    setShowModalDepartmentSettings={setShowModalDepartmentSettings} 
                    setShowModalArticlesSettings={setShowModalArticlesSettings}  
                    isArticle={false}  
                    setShowModalPurchasesDeliverySettings={setShowModalPurchasesDeliverySettings}
                    isPurchasesDelivery={false}
                />
                <ArticlesButtonSettings  
                    showArticlesButtonSettings={showArticlesButtonSettings}
                    setShowArticlesButtonSettings={setShowArticlesButtonSettings} 
                    setIndexShowSettings={setIndexShowSettings} 
                    setShowModalGeneralSettings={setShowModalGeneralSettings} 
                    setShowModalEmployeeSettings={setShowModalEmployeeSettings}
                    isEmployee={false} 
                    setShowModalStoreSettings={setShowModalStoreSettings}
                    isStore={false} 
                    setShowModalFormSettings={setShowModalFormSettings}
                    isForm={false}
                    setShowModalContractSettings={setShowModalContractSettings}
                    isContract={false} 
                /> 
                </div>
                {/* End of Main Content */}

                {/* Footer */}
                    <Footer/>
                {/* End of Footer */}

            </div>
            {/* End of Content Wrapper */}

          </div>
          {/* End of Page Wrapper */}
         


      </div>}
      {/* End of Body */}

    </>
  )
};

export default Home;
